(() => {
	angular.module('main').controller('TlcController', TlcController);

	TlcController.$inject = ['$scope', '$rootScope', 'accountService'];

	function TlcController($scope, $rootScope, accountService) {
		$scope.$on('$viewContentLoaded', () => {
			$rootScope.signInPage = false;
		});

		accountService.emitShowHeader(false);
		$rootScope.showLogo = false;
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/tlcController.js